'use client';

import React from 'react';

import { useMealTranslation } from '@/hooks/useMealTranslation';

export interface MealTextProviderRenderProps {
  name: string;
  description: string | null;
  isTranslated: boolean;
}

export interface MealTextProviderProps {
  mealId?: string;
  fallbackName: string;
  fallbackDescription?: string | null;
  children: (translated: MealTextProviderRenderProps) => React.ReactNode;
}

/**
 * Provides localized meal copy to child render functions.
 */
export const MealTextProvider = React.memo(function MealTextProvider({
  mealId,
  fallbackName,
  fallbackDescription = null,
  children,
}: MealTextProviderProps) {
  const translated = useMealTranslation(mealId, fallbackName, fallbackDescription);

  return <>{children(translated)}</>;
});
